import { createSlice } from "@reduxjs/toolkit";
import { createEventRequestThunk } from "./createEventRequestThunk";
import { fetchEventRequestsThunk } from "./createEventRequestThunk";

const eventRequestSlice = createSlice({
  name: "eventRequest",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: []
  },
  reducers: {
    resetEventRequestStatus: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEventRequestThunk.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createEventRequestThunk.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createEventRequestThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error occurred';
      })
      .addCase(fetchEventRequestsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventRequestsThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (JSON.stringify(state.data) !== JSON.stringify(action.payload)) {
          state.data = action.payload;
        }
      })
      .addCase(fetchEventRequestsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetEventRequestStatus } = eventRequestSlice.actions;
export default eventRequestSlice.reducer;
